import React, { useMemo } from 'react';

import { Button } from '@/Components/shadcn/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/Components/shadcn/dialog';
import ProcessingState from '@/Models/ProcessingState';
import HttpErrorTypes from '@/Utils/HTTP/Errors/HttpErrorType';
import UIStrings from '@/Utils/UIStrings';
import { useCreateRecruitmentContext } from '../../../Create/Contexts/CreateRecruitmentContext';

const errorToMessage = (e?: HttpErrorTypes): [string, string] => {
    switch (e) {
        case HttpErrorTypes.TooManyRequests:
            return [UIStrings.ExperienceCriteriaCouldNotBeGenerated, UIStrings.ExperienceCriteriaLimitError];
        default:
            return [UIStrings.ExperienceCriteriaCouldNotBeGenerated, UIStrings.ExperienceCrtieriaGenericError];
    }
};

function IdentifyExperienceErrorDialog() {
    const { experienceCriteriaError, experienceCriteriaProcessingState, resetExperienceCriteriaProcessingState } =
        useCreateRecruitmentContext();
    const open = useMemo(
        () => experienceCriteriaProcessingState === ProcessingState.Error,
        [experienceCriteriaProcessingState],
    );
    const [title, description] = useMemo(() => errorToMessage(experienceCriteriaError), [experienceCriteriaError]);

    return (
        <Dialog open={open} onOpenChange={(v) => !v && resetExperienceCriteriaProcessingState()}>
            <DialogContent showCloseButton={false} className="max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription className="whitespace-pre-line">{description}</DialogDescription>
                </DialogHeader>
                <DialogFooter className="justify-center sm:justify-center">
                    <Button onClick={resetExperienceCriteriaProcessingState}>{UIStrings.IUnderstand}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default IdentifyExperienceErrorDialog;
